import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-3 justify-content-end border-top-1 surface-border col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Button, {
      onClick: _cache[0] || (_cache[0] = $event => _ctx.closeDialog()),
      label: "Cancel",
      class: "p-button-text"
    })
  ]))
}